import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CardHeaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    passThrough: {
        pointerEvents: "box-none"
    },
    text: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    },
    inert: {
        pointerEvents: "none"
    }
});

export const useStyles = ({
    isDivided,
    borders,
    colors,
    spaces,
    inset
}: CardHeaderDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: inset,
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>,
        text: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    if(isDivided) {
        Object.assign(styles.container, {
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator,
            paddingBottom: inset
        });
    }

    return styles;
};
export default stylesheet;
